/** Shared Prisma-style filter for active marketplace listings (Buy + seller listings). */
export const marketplaceBuyableWhere = {
  quantity: { gt: 0 },
  isActive: { equals: true },
  Pharmacy: {
    is: {
      PharmacyStatus: {
        is: {
          Status: {
            is: {
              key: { notIn: ["EXPIRED", "REJECTED", "PENDING"] },
            },
          },
        },
      },
    },
  },
};
